var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "add-ent-id",
          attrs: {
            title: "信息提示",
            visible: _vm.visibleCredit,
            "close-on-click-modal": false,
            width: "730px"
          },
          on: {
            "update:visible": function($event) {
              _vm.visibleCredit = $event
            },
            open: _vm.openDialog,
            close: _vm.closeDialog
          }
        },
        [
          _c(
            "div",
            { staticClass: "box-main" },
            [
              _c("p", { staticClass: "err-title" }, [
                _c("img", {
                  attrs: { src: require("../../static/images/warning.png") }
                }),
                _vm._v(
                  "以下数据填写错误或无数据，请核实，若是海外企业请前往国际版发起！"
                )
              ]),
              _c(
                "el-form",
                {
                  ref: "ruleForm",
                  staticClass: "twoColumn",
                  attrs: { model: _vm.entCreditJson, "label-width": "100px" }
                },
                [
                  _vm.entCreditArr && _vm.entCreditArr.length
                    ? _vm._l(_vm.entCreditArr, function(item, index) {
                        return _c(
                          "div",
                          { key: "ent" + index, staticClass: "myRow" },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "公司名称：" } },
                              [
                                _c("el-input", {
                                  attrs: {
                                    size: "small",
                                    value: item,
                                    placeholder: item,
                                    disabled: true
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "营业执照号：",
                                  prop: item,
                                  rules: _vm.rules.businessLicenseNo
                                }
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    size: "small",
                                    placeholder: "请输入"
                                  },
                                  model: {
                                    value: _vm.entCreditJson[item],
                                    callback: function($$v) {
                                      _vm.$set(_vm.entCreditJson, item, $$v)
                                    },
                                    expression: "entCreditJson[item]"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      })
                    : _vm._e(),
                  _vm.userIdentityInfoArr && _vm.userIdentityInfoArr.length
                    ? _vm._l(_vm.userIdentityInfoArr, function(item, index) {
                        return _c(
                          "div",
                          { key: "user" + index, staticClass: "myRow" },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "姓名：" } },
                              [
                                _c("el-input", {
                                  attrs: {
                                    size: "small",
                                    value: item.name,
                                    placeholder: "姓名",
                                    disabled: true
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              { attrs: { label: "身份证号码：" } },
                              [
                                _c("el-input", {
                                  attrs: {
                                    size: "small",
                                    value: item.identityNo,
                                    placeholder: "中国大陆身份证号码",
                                    disabled: true
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      })
                    : _vm._e()
                ],
                2
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dailog-footer",
              staticStyle: { "margin-top": "20px" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn",
                  attrs: { size: "small" },
                  on: { click: _vm.sureFn }
                },
                [_vm._v(_vm._s(_vm.sureText))]
              ),
              _c(
                "el-button",
                {
                  staticClass: "btn",
                  attrs: { type: "danger", size: "small" },
                  on: {
                    click: function($event) {
                      return _vm.$emit("cancel")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.cancelText))]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3fc64586", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3fc64586","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/contract/signInfoTipsDialog.vue
// module id = /FgQ
// module chunks = 2 3 6 8 15 16 18 19 33 35 36 44 45 46